import { useStableNavigate } from "@mirage/hooks/useStableNavigate";
import { PrePublicPortalWLRoutingService } from "@prePublicPortalWestLindsay/services/PrePublicPortalWLRoutingService";
import { Button } from "govuk-react";
import React, { memo } from "react";
import useSessionStorage from "@mirage/hooks/useSessionStorage";
import Box from "@mui/material/Box";

const router = new PrePublicPortalWLRoutingService();

export const PrePpWlDisclaimer = memo(() => {
    const navigate = useStableNavigate();
    const consentOnClick = () => {
        navigate(router.FormApplicantDetailsRoute());
    };
    const [sessionStorage] = useSessionStorage("prePublicPortalWestLindsay");
    const defaultFallback = `<H3>Disclaimer</H3>
            <p>
                Advice given by officers for pre-application enquiries does not indicate a formal decision by the council. Any views or opinions given are without prejudice to the
                formal consideration of any planning or other application. The final decision on any application that you may then make can only be taken after the council has
                consulted local people, statutory consultees and any other interested parties and will then be made either by the Planning Committee, or under delegated power’s in
                accordance with the council’s approved Scheme of Delegation, based on all information available at the time. Officer’s cannot therefore guarantee the final formal
                decision that will be made on your application(s). Pre-application advice given is advisory only and if you were to purchase any land/buildings on the advice of the
                pre-application assessment you do so at your own risk, as the council would nt be held accountable if a scheme was not supported at a later date.
            </p>
            <H3>Freedom of Information</H3>
            <p>
                You are advised that your pre-application enquiry may be required to be disclosed should there be a request under the Freedom of Information Act and as such this
                council is not able to ensure your enquiry is confidential.
            </p>
            <H3>Statement</H3>
            <p>
                By submitting this form you confirm that you are seeking pre-application advice on the proposed development described in this application and have read the
                Disclaimer and Freedom of Information statements above.
            </p>
            <H3>West Lindsey District Council Privacy Notice</H3>
            <p>
                To find out more about why we need your information, what we will do with it and how to contact us if you have any concerns or questions please read our Privacy
                Notice at https://www.west-lindsey.gov.uk/privacy For Planning specific concerns or questions please read our Planning Privacy Notice at
                https://www.west-lindsey.gov.uk/privacy/planning-privacy-notice/ If you require a written copy of either of these statements please contact the Customer Service
                team on 01427 676676.
            </p>`;
    const content = sessionStorage?.clientSettings?.DISCLAIMER || defaultFallback;

    return (
        <>
            <Box dangerouslySetInnerHTML={{ __html: content }} marginBottom={2} />
            <Button onClick={consentOnClick}>Consent</Button>
        </>
    );
});
